import React from "react";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import Acid1 from "../../../assets/technology/acidtech/acid1.png";
import Acid2 from "../../../assets/technology/acidtech/acid2.png";

const AboutDetail = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        maxWidth: "100%",
        flexDirection:"column",
        width: { xs: "100%", sm: "100%" },
        // pt: { xs: 2, sm: 10 },
        // pb: { xs: 2, sm: 10 },
      }}
    >
      {/* <Roll right> */}
      <Typography
        component="h1"
        variant="h1"
        sx={{
          display: "flex",
          //  flexDirection: { xs: "column", md: "row" },
          justifyContent: "start",
          alignSelf: "start",
          textAlign: "start",
          fontSize: { xs: "4rem", sm: "3rem" },
          borderBottom: "2px solid black",
          width: "100%",
          borderBottomWidth: "2px",
        }}
      >
        AICD Technology
      </Typography>
      <Box>
        {/* </Roll> */}
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            lineHeight: "1.6", // Adjust the line height value as needed
            letterSpacing: "0.5px", // Adjust the letter spacing value as needed
            fontWeight: "bold", // Adjust the font weight value as needed (e.g., 'bold', 'normal', etc.)
            fontSize: "16px",
            paddingTop: "20px",
            // gap: "20px", // Add gap between the images
            // padding: "20px", // Add padding around the images
            //  width: { xs: "100%", sm: "50%",md:"100%" },
          }}
        >
          RESELTECH  AICD & AICV Intelligent Water Control Completion
          System is a comprehensive process system that focuses on reducing
          water cut in oil wells, increasing oil production and enhancing oil
          recovery.
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            lineHeight: "1.6", // Adjust the line height value as needed
            letterSpacing: "0.5px", // Adjust the letter spacing value as needed
            fontWeight: "bold", // Adjust the font weight value as needed (e.g., 'bold', 'normal', etc.)
            fontSize: "13px",
            paddingTop: "20px",
            // gap: "20px", // Add gap between the images
            // padding: "20px", // Add padding around the images
            //  width: { xs: "100%", sm: "50%",md:"100%" },
          }}
        >
          RESELTECH  AICD & AICV Intelligent Water Control Completion
          System is a comprehensive process system that focuses on reducing
          water cut in oil wells, increasing oil production and enhancing oil
          recovery.
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            lineHeight: "1.6", // Adjust the line height value as needed
            letterSpacing: "0.5px", // Adjust the letter spacing value as needed
            fontWeight: "bold", // Adjust the font weight value as needed (e.g., 'bold', 'normal', etc.)
            fontSize: "13px",
            paddingTop: "20px",
            // gap: "20px", // Add gap between the images
            // padding: "20px", // Add padding around the images
            //  width: { xs: "100%", sm: "50%",md:"100%" },
          }}
        >
          The features of the  AICD & AICV Intelligent Water Control
          solution are as follows： <br />
          A. Apply to sandstone, carbonate rock, volcanic rock, metamorphic
          rock, heavy oil reservoir, etc;
          <br /> B. Applicable to horizontal well, vertical well, directional
          well;
          <br /> C. Suitable for Severe heterogeneity,multi-layer development
          reservoir with edge and bottom water;
          <br /> D. Applied to new wells at risk of water coning and production
          wells where water coning has occurred;
          <br /> E.Can be applied to open hole completion, casing and screen
          production well re-completion； <br />
          F.One-time completion operation realizes self-adaptive water control
          and oil increase in the whole life cycle of oil well production；
          <br />
          G. AICD & AICV water control screen has no moving parts;simple
          completion string,simple operation procedure and low overall cost;
          <br />
          H.No control lines and human intervention on the ground are required
          to realize low-cost intelligent flow regulation and water control
          completion.
        </Typography>
        <Box>
          <img
            src={Acid1}
            alt=" Vertical and Directional Well Water Control Solution"
            style={{
              display: "block", // Ensures the image is treated as a block element
              margin: "auto", // Center the image horizontally
              // width: '70%',    // Ensure the image takes the full width of its container
              height: "auto", // Maintain aspect ratio
              maxWidth: "100%", // Ensure the image doesn't exceed the container width
            }}
          />
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              lineHeight: "1.6", // Adjust the line height value as needed
              letterSpacing: "0.5px", // Adjust the letter spacing value as needed
              fontWeight: "bold", // Adjust the font weight value as needed (e.g., 'bold', 'normal', etc.)
              fontSize: "13px",
              paddingTop: "20px",
              textAlign: "center",
              // gap: "20px", // Add gap between the images
              // padding: "20px", // Add padding around the images
              //  width: { xs: "100%", sm: "50%",md:"100%" },
            }}
          >
            Vertical and Directional Well Water Control Solution
          </Typography>
        </Box>
        <Box>
          <img
            src={Acid2}
            alt="Horizontal new well Water Control Solution"
            style={{
              display: "block", // Ensures the image is treated as a block element
              margin: "auto", // Center the image horizontally
              // width: '70%',    // Ensure the image takes the full width of its container
              height: "auto", // Maintain aspect ratio
              maxWidth: "100%", // Ensure the image doesn't exceed the container width
            }}
          />
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              lineHeight: "1.6", // Adjust the line height value as needed
              letterSpacing: "0.5px", // Adjust the letter spacing value as needed
              fontWeight: "bold", // Adjust the font weight value as needed (e.g., 'bold', 'normal', etc.)
              fontSize: "13px",
              paddingTop: "20px",
              textAlign: "center",
              // gap: "20px", // Add gap between the images
              // padding: "20px", // Add padding around the images
              //  width: { xs: "100%", sm: "50%",md:"100%" },
            }}
          >
            Horizontal new well Water Control Solution
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutDetail;
